<template>
  <div>
    <div
      v-if="!mewsAuthenticated"
      class="
        col-sm-10
        offset-sm-2
        col-md-8
        offset-md-2
        col-lg-8
        offset-lg-2
        text-center
      "
    >
      <div class="b-button-group m-2">
        <b-dropdown
          id="languageDropDown"
          size="md"
          variant="dark"
          class="m-md-2"
        >
          <template #button-content>
            <b-icon icon="file-text" aria-hidden="true"></b-icon>
            {{ currentLanguage }}
          </template>
          <b-dropdown-item
            v-for="entry in languages"
            :key="entry.title"
            @click="changeLocale(entry.language)"
          >
            {{ entry.title }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <b-card>
        <center>
          <img
            src="/static/LogoCompleto_Vertical_Gris_Vectorial.png"
            class="d-md-block img-responsive"
            alt="Logo image"
            width="50%"
          />
        </center>

        <hr class="my-4" />

        <p class="card-text mx-2 mt-4 px-2" style="text-align: center">
          {{ $i18n.t("login.subtitle") }}
        </p>

        <b-card-body class="card-body">
          <b-form @submit.prevent="onSubmit">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">
                  <font-awesome-icon :icon="['fa', 'user']" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="lastName"
                v-model="form.lastName"
                class="form-control"
                size="md"
                :placeholder="$i18n.t('login.lastname')"
                required
              ></b-form-input>
            </b-input-group>

            <b-input-group class="my-3">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <font-awesome-icon :icon="['fa', 'door-open']" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="roomNumber"
                v-model="form.roomNumber"
                class="form-control"
                size="md"
                :placeholder="$i18n.t('login.roomnumber')"
                required
              ></b-form-input>
            </b-input-group>

            <hr class="my-4" />

            <b-form-checkbox
              id="checkbox1"
              @input="changeTerms"
              value="true"
              color="green"
              unchecked-value="false"
            >
              <a class="mx-2" href="/terms">{{
                $i18n.t("login.termsconditions")
              }}</a>
            </b-form-checkbox>

            <div class="text-center py-4 mt-2">
              <b-button variant="dark" type="submit" block>
                {{ $i18n.t("login.connect") }}
              </b-button>
            </div>
          </b-form>
        </b-card-body>
      </b-card>
    </div>
    <div
      v-if="mewsAuthenticated"
      class="col-sm-10 offset-sm-1 offset-md-1 col-md-8 text-center"
    >
      <div class="card">
        <h4>
          {{ $i18n.t("login.greetings") }} {{ customer.customer.FirstName }}!
        </h4>
        <p>{{ $i18n.t("login.logInMsg") }}</p>
      </div>
      <p class="details">
        <label>{{ $i18n.t("login.client") }} MAC | </label> {{ clientMac }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  components: {},
  data() {
    return {
      clientMac: "",
      baseGrantUrl: "",
      userContinueUrl: "",
      clientIp: "",
      nodeMac: "",
      customer: {
        customer: {
          id: ""
        }
      },
      form: {
        lastName: "",
        roomNumber: "",
        terms: false
      },
      mewsAuthenticated: false,
      languages: [
        { language: "ca", title: "Català" },
        { language: "es", title: "Español" },
        { language: "en", title: "English" },
        { language: "fr", title: "Français" }
      ]
    };
  },
  mounted() {
    if (localStorage.getItem("locale")) {
      this.$root.$i18n.locale = localStorage.getItem("locale");
    } else {
      if (["ca", "es", "en", "fr"].includes(navigator.languages[1])) {
        localStorage.setItem("locale", navigator.languages[1]);
        this.$root.$i18n.locale = navigator.languages[1];
      }
    }
  },
  computed: {
    currentLanguage: function() {
      return this.languages.find(
        entry => entry.language === this.$root.$i18n.locale
      ).title;
    },
    loginUrl() {
      const sessionTimeout = 604800; //7 days session (in seconds)
      return (
        this.baseGrantUrl +
        "?continue_url=" +
        this.userContinueUrl +
        "&duration=" +
        sessionTimeout
      );
    }
  },
  created() {
    //console.log("route query", this.$route.query);
    this.clientMac = this.$route.query.client_mac;
    this.baseGrantUrl = this.$route.query.base_grant_url;
    this.userContinueUrl = this.$route.query.user_continue_url;
    this.clientIp = this.$route.query.client_ip;
    this.nodeMac = this.$route.query.node_mac;
  },
  methods: {
    onSubmit() {
      // verify data
      if (!this.form.terms || this.form.terms == "false") {
        this.$toasted.error(this.$i18n.t("login.noagrmnt"));
        return;
      }
      // authorize client (search DB)
      if (this.form.lastName && this.form.roomNumber) {
        this.mewsAuthNameRoom().then(res => {
          console.log("mewsAuthNameRoom res", res.data);
          this.customer = res.data;
          if (this.customer.authorized) {
            console.log("mewsAuthNameRoom success");
            this.mewsAuthenticated = true;
            this.login();
          } else {
            console.log("mewAuthNameRoom failed. Aborting login");
            this.$toasted.error(this.$i18n.t("login.authfailed"));
          }
        });
      }
    },
    changeTerms(value) {
      this.form.terms = value;
    },
    changeLocale(locale) {
      localStorage.setItem("locale", locale);
      this.$root.$i18n.locale = locale;
    },
    mewsAuthNameRoom() {
      return this.axios
        .post("/mews/authNameRoom", {
          Name: this.form.lastName,
          RoomNumber: this.form.roomNumber
        })
        .then(res => {
          return res;
        });
    },
    merakiLogin() {
      console.log("Form data submitted");

      if (!this.baseGrantUrl) {
        console.log("login failed, no base grant url");
        return;
      }
      // ** Login to Meraki by redirecting client to the base_grant_url **
      console.log("Redirecting to base_grant_url: ", this.loginUrl);
      window.location.href = this.loginUrl; //proper way
    },
    async login() {
      this.merakiLogin();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.details {
  background-color: #b8b8b8bb;
}

@media (max-width: 400px) {
  .b-button-group {
    margin-left: -20px !important;
    margin-right: -20px !important;
  }
  .b-button-group * {
    font-size: 14px;
    padding: 5px !important;
  }
}
@media (max-width: 300px) {
  .b-button-group * {
    font-size: 12px;
    padding: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue